//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import {
    APP_DATE_DOT_FORMAT,
    APP_DATE_HOUR_MIN_FORMAT,
    APP_DATE_DOT_DMY_FORMAT
} from "@/assets/js/appConfig";
import FabricSearch from "@/components/q-fabric-search.vue";
import { setPluginIcon,
    convertAndFormatTimeToLocal,
    formatTimeToSend,
    copyToClipboard,
    eventBus } from "@/assets/js/appFunc";
import i18n from "@/i18n/index";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";

import tabComponents from "../mixins/tab-components";

export default {
    components: {
        FabricSearch,
        AQInput,
        AQCard,
        AQButton,
        AQMenu,
        AQTooltip,
        AQDialog,
        AQBadge

    },
    filters: {
        extension: value => {
            const formattedValue = value.split(".");
            if (formattedValue.length === 1) {
                return i18n.t("admin.processInspector.other");
            }
            return formattedValue[formattedValue.length - 1];
        }
    },
    mixins: [tabComponents],
    props: {
        systemStatus: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            APP_DATE_HOUR_MIN_FORMAT,
            APP_DATE_DOT_FORMAT,
            docsList: [],
            showLoadMoreDocBtn: false,
            searchDoc: "",
            fromDateDoc: "",
            toDateDoc: "",
            noFromDateDocFound: false,
            noToDateDocFound: false,
            showClearIconFrom: true,
            showClearIconTo: true,
            docsPayload: {
                dateFrom: "",
                dateTo: "",
                generalSearch: "",
                page: 0,
                processInstanceId: "",
                size: 5,
                sortDirection: "DESC",
                sortField: "modifiedOn"
            },
            docListExists: true,
            showPopupAll: [],
            showPopup: [],
            optionsMenuDownloadAll: [
                {
                    value: "previewSC",
                    label: this.$t("admin.processInspector.downloadAll")
                }
            ],
            optionsMenuDownload: [
                {
                    value: "download",
                    label: this.$t("documents.download")
                },
                {
                    value: "delete",
                    label: this.$t("documents.delete"),
                    itemDisabled: this.systemStatus === "RUNNING" || this.systemStatus === "FAILED"
                }
            ],
            openDialog: false,
            deletedDoc: null,
            updatedDocList: [],
            currentDocNameToDelete: "",
            notDeletedDoc: false
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        currentDateTime() {
            const currentDate = new Date();
            const todayDate = `${currentDate.getFullYear()
            }-${
                this.formatDate(currentDate.getMonth() + 1)
            }-${
                this.formatDate(currentDate.getDate())}`;
            const todayTime = `${this.formatDate(currentDate.getHours())
            }:${
                this.formatDate(currentDate.getMinutes())
            }:${
                this.formatDate(currentDate.getSeconds())
            }.${
                currentDate.getMilliseconds() < 100 ? "0" : ""
            }${currentDate.getMilliseconds() < 10 ? "0" : ""
            }${currentDate.getMilliseconds()}`;
            return `${todayDate}T${todayTime}`;
        }
    },
    watch: {
        toDateDoc: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "toStartDateDoc");
            }
        },
        fromDateDoc: {
            handler(newValue) {
                this.updateDate(newValue);
                this.showClearIconFunc(newValue, "fromStartDateDoc");
            }
        },
        systemStatus: {
            handler(newValue) {
                if (newValue !== "RUNNING" || newValue !== "FAILED") {
                    this.isDisabledMenu();
                }
            }
        }
    },
    beforeDestroy() {
        eventBus.$off("documentsRefreshTab");
    },
    mounted() {
        this.docsDetailsCall();
        eventBus.$on("documentsRefreshTab", () => {
            this.docsDetailsCall();
        });
    },
    methods: {
        ...mapActions("admin", ["getDocsDetails", "downloadAllDocs", "deleteDocumentPI"]),
        setPluginIcon,
        convertAndFormatTimeToLocal,
        copyToClipboard,
        formatTimeToSend,
        isDisabledMenu() {
            this.optionsMenuDownload[1].itemDisabled = false;
            this.optionsMenuDownload = this.optionsMenuDownload.map(elem => elem);
        },
        downloadDoc(doc, event) {
            if (event[0].value === "delete") {
                this.deletedDoc = {
                    attachmentId: doc.id,
                    processInstanceId: this.getProcessInspectorById.rootProcessInstanceId
                };
                this.currentDocNameToDelete = doc.fileName;
                this.openDialog = true;
            } else {
                window.open(`/data/attachment/download/attachment/${doc.id}`);
            }
            this.showPopup = [];
        },
        deletedMessage(message) {
            let docName = message.fileName;
            if (message.deleted) {
                docName = this.$t("admin.processInspector.deletedDoc",
                    { user: message.deleteEventDTO.username,
                        time: this.convertAndFormatTimeToLocal(message.deleteEventDTO.execDate, APP_DATE_DOT_DMY_FORMAT) });
            }
            return docName;
        },

        okAction() {
            this.deleteDocumentPI(this.deletedDoc).then(data => {
                const docIndex = this.docsList.findIndex(elem => elem.id === this.deletedDoc.attachmentId);
                this.docsList[docIndex].deleteEventDTO = data;
                this.showNotify();
                this.docsDetailsCall();
                this.currentDocNameToDelete = "";
                this.$root.$emit("refreshTimeline");
            });
        },
        cancelAction() {
            this.currentDocNameToDelete = "";
            this.openDialog = false;
        },
        showNotify() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("documents.deleteConfirmation", { type: this.currentDocNameToDelete }),
                timeout: 500
            });
        },
        downloadAllDoc() {
            const payload = [];
            for (let i = 0; i < this.updatedDocList.length; i++) {
                payload.push(this.updatedDocList[i].id);
            }
            this.downloadAllDocs(payload).then(data => {
                const fileType = "application/zip";
                const blob = new Blob([data.data], { type: fileType });
                const aTag = document.createElement("a");
                const url = URL.createObjectURL(blob);
                aTag.href = url;
                window.open(aTag);
            });
        },
        convertSize(value) {
            let newSize = "";
            if (value < 1000000) {
                newSize = `${(value / 1000).toFixed(2)} KB`;
            } else {
                newSize = `${(value / 1000000).toFixed(2)} MB`;
            }
            return newSize;
        },
        showClearIconFunc(value, state) {
            if (state === "fromStartDateDoc") {
                this.showClearIconFrom = !!value;
            } else if (state === "toStartDateDoc") {
                this.showClearIconTo = !!value;
            }
        },
        updateDate(value) {
            const fromDate = this.fromDateDoc;
            const toDate = this.toDateDoc;
            const payload = this.docsPayload;

            if (value) {
                if (fromDate && toDate) {
                    this.noFromDateDocFound = false;
                    this.noToDateDocFound = false;
                    payload.dateFrom = this.formatTimeToSend(
                        fromDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.dateTo = this.formatTimeToSend(
                        toDate,
                        APP_DATE_HOUR_MIN_FORMAT
                    );
                    payload.size = 5;
                    this.docsDetailsCall();
                } else if (!fromDate && toDate) {
                    this.noFromDateDocFound = true;
                } else if (fromDate && !toDate) {
                    this.noToDateDocFound = true;
                }
            }
        },
        updateModel(isFrom) {
            const fromDate = this.fromDateDoc;
            const toDate = this.toDateDoc;
            if (isFrom) {
                this.fromDateDoc = "";
                if (toDate) {
                    this.noFromDateDocFound = true;
                    this.noToDateDocFound = false;
                } else {
                    this.noToDateDocFound = false;
                    this.setPayloadOnUpdateModel();
                }
            } else {
                this.toDateDoc = "";
                if (fromDate) {
                    this.noFromDateDocFound = false;
                    this.noToDateDocFound = true;
                } else {
                    this.noFromDateDocFound = false;
                    this.setPayloadOnUpdateModel();
                }
            }
        },
        setPayloadOnUpdateModel() {
            this.noFromDateDocFound = false;
            this.docsPayload.dateFrom = "";
            this.docsPayload.dateTo = "";
            this.docsPayload.size = 5;
            this.docsDetailsCall();
        },
        docsDetailsCall(loadMore) {
            this.docsPayload.processInstanceId = this.getProcessInspectorById.rootProcessInstanceId;
            if (!loadMore) {
                this.docsPayload.page = 0;
            }
            this.getDocsDetails(this.docsPayload).then(data => {
                this.updatedDocList = loadMore ? this.updatedDocList.concat(data.data.list.filter(doc => !doc.deleted))
                    : data.data.list.filter(doc => !doc.deleted);
                this.docsList = loadMore ? this.docsList.concat(data.data.list) : data.data.list;
                this.showLoadMoreDocBtn = this.docsPayload.size * (this.docsPayload.page + 1) < data.data.totalElements;
                this.docListExists = data.data.list && data.data.list.length;
                this.notDeletedDoc = this.updatedDocList && this.updatedDocList.length;
            });
        },

        formatDate(value) {
            return value < 10 ? `0${value}` : value;
        },
        loadMoreItems() {
            ++this.docsPayload.page;
            this.docsDetailsCall(true);
        },
        searchTermDataDoc(value) {
            this.docsPayload.generalSearch = value;
            this.docsPayload.size = 5;
            this.docsDetailsCall();
        }
    }
};
